import React from 'react';
import TippyTip from '@tippyjs/react';
import PropTypes from 'prop-types';

import 'tippy.js/dist/tippy.css';

const Tooltip = ({ children, wrapperClassName, ...props }) => (
  <TippyTip {...props}>
    <div className={wrapperClassName}>{children}</div>
  </TippyTip>
);

Tooltip.defaultProps = {
  wrapperClassName: 'tooltip-wrapper'
};

Tooltip.propTypes = {
  children: PropTypes.element.isRequired,
  wrapperClassName: PropTypes.string
};

export default Tooltip;
